@if (!showPlanning()) {
  <div class="flex flex-col gap-2">
    <div class="text-base font-semibold mt-4">{{ 'addGuest' | translate }}</div>
    <button class="justify-center text-sm w-full mt-4 md:w-1/2 md:ml-[25%]"
            appHoverGradient
            [disabled]="invitationListForm.controls.length > 2"
            (click)="addInvitation()">
      {{ 'addGuest.action' | translate }}
    </button>
    @if (invitationListForm.controls.length) {

      <p class="text-base text-gray-600">{{ 'addGuest.description' | translate }}</p>
    }
    @for (control of invitationListForm.controls; track control; let idx = $index) {
      <div [formGroup]="control" class="flex flex-col md:flex-row gap-2 items-center mt-4">
        <div class="w-full md:w-fit flex items-center gap-2">
          <input [id]="'gender-male-'+idx"
                 type="radio"
                 formControlName="gender"
                 [value]="Gender.Male"
                 class="w-4 h-4 border-gray-300 text-100ciels-300 focus:ring-0 disabled:text-gray-500">
          <label [for]="'gender-male-'+idx"
                 class="ms-2 text-base font-medium text-gray-500">{{ 'mister' | translate }}</label>
          <input [id]="'gender-female-'+idx"
                 type="radio"
                 formControlName="gender"
                 [value]="Gender.Female"
                 class="w-4 h-4 border-gray-300 text-100ciels-300 focus:ring-0 disabled:text-gray-500">
          <label [for]="'gender-female-'+idx"
                 class="ms-2 text-base font-medium text-gray-500">{{ 'mrs' | translate }}</label>

          <div role="button" tabindex="0" class="md:hidden w-full"
               (click)="invitationListForm.removeAt(idx)"
               (keyup.enter)="emulateClick($event)">
            <img alt="" width="36" height="36" ngSrc="assets/icons/dark/trashcan.svg"
                 class="w-6 h-6 md:w-8 md:h-8 justify-self-end">
          </div>
        </div>

        <div class="w-full flex flex-col md:flex-row gap-2">
          <div class="w-full md:w-1/2">
            <input
              [id]="'firstname-'+idx"
              formControlName="firstname"
              placeholder="{{ 'firstName' | translate }}"
              class="appearance-none block w-full border-gray-200 text-gray-700 border rounded-lg py-4 px-4 leading-tight focus:outline-none focus:bg-white disabled:bg-gray-100"
              type="text">
          </div>
          <div class="w-full md:w-1/2">
            <input
              [id]="'lastname-'+idx"
              formControlName="lastname"
              placeholder="{{ 'lastName' | translate }}"
              class="appearance-none block w-full border-gray-200 text-gray-700 border rounded-lg py-4 px-4 leading-tight focus:outline-none focus:bg-white disabled:bg-gray-100"
              type="text">
          </div>
          <div class="w-full md:w-1/2">
            <input
              [id]="'email-'+idx"
              formControlName="email"
              placeholder="{{ 'email' | translate }}"
              class="appearance-none block w-full border-gray-200 text-gray-700 border rounded-lg py-4 px-4 leading-tight focus:outline-none focus:bg-white disabled:bg-gray-100"
              type="text">
          </div>
        </div>

        <div role="button" tabindex="0" class="hidden md:block"
             (click)="invitationListForm.removeAt(idx)"
             (keyup.enter)="emulateClick($event)">
          <img alt="" width="36" height="36" ngSrc="assets/icons/dark/trashcan.svg"
               class="w-6 h-6 md:w-8 md:h-8">
        </div>
      </div>
    }

    <div class="flex md:flex-row gap-2 mt-4 justify-center">
      <button class="basis-full md:basis-1/2 grow-0 main-btn" [disabled]="invitationListForm.invalid || cartSaving()"
              appHoverGradient
              (click)="validateInvitations()">
        @if (invitationListForm.controls.length; as count) {
          {{ 'continueBookingWithGuest' | translate : {number: count.toString()} }}
        } @else {
          {{ 'continueBooking' | translate }}
        }
      </button>
    </div>
  </div>
} @else {
  <div class="flex flex-col gap-12 md:flex-row place-content-between relative">
    <div class="grow">
      <div class="h-24 flex items-center border-b border-gray-200 gap-4 mb-5">
        @if (this.isInitiation()) {
          <button (click)="showPlanning.set(false)" class="stroke-gray-500 p-2">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 class="size-6" stroke-width="1.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3"/>
            </svg>
          </button>
        }
        <svg class="fill-100ciels-300 h-10 w-10" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"/>
        </svg>
        <p class="text-xl text-100ciels-300 font-semibold">{{ 'nextSessionTitle' | translate }}</p>
      </div>
      @if (updatePlanningProgress()) {
        <div class='w-full'>
          <div class='h-1 w-full bg-gray-300 overflow-hidden'>
            <div class='progress w-full h-full bg-100ciels-300 left-right'></div>
          </div>
        </div>
      } @else {
        @if (availableDays().length) {
          <app-date-picker [customs]="availableDays()" (selectedDataChange)="selectDay($event)"
                           [notBefore]="selectedPeriod().from" [notAfter]="selectedPeriod().to"
                           defaultClasses="line-through"
          ></app-date-picker>
        } @else {
          <p class="text-gray-500 font-semibold">{{ 'noSpaAvailabilities' | translate }}
            <a href="mailto:{{spaEmail()}}" class="font-bold text-100ciels-300">{{ spaEmail() }}</a>.</p>
        }
      }
    </div>
    @if (!updatePlanningProgress()) {
      @if (availableSlots(); as slots) {
        <div #timeSlots>
          <div class="h-24 flex flex-col border-b border-gray-200 gap-4 mb-5">
            <div class="text-gray-500 font-semibold"
                 [ngClass]="{ 'mt-10' : !hasHammam()}">{{ 'selectAnHour' | translate }}</div>
            @if (hasHammam()) {
              <div class="flex items-center">
                <svg class="size-6" viewBox="0 0 5000 5000">
                  <g>
                    <path
                      d="M3953.91,2313.46c160.3-75.58,167.2-133.98,155.61-163.13-4.07-10.36-11.66-18.8-20.95-24.94-83.48-55.02-154.85-127.68-218.23-204.57-26.7-32.46-53.64-67.06-75.51-104.43,96.07-34.84,159.76-112.65,159.76-112.65-64.15,42.28-140.65,55.71-185.54,59.93-1.61-3.91-3.3-7.83-4.68-11.82-25.32-71.67-17.57-150.01-31.15-224.06-22.33-122.08-60.39-241.32-116.4-352.2-81.11-160.37-199.58-301.33-345.37-406.61-58.01-41.9-122.08-82.87-189.91-107.2,182.39,246.62,257.21,593.22,242.55,893.55-14.89,305.63-129.22,588.31-295.34,841.76-169.35,258.21-355.73,497.46-436.92,800.94-51.64,193.14-60.77,394.33-28.08,586.08-7.21-15.42-244.55-543.5,304.78-1576.71,603.73-1135.49-175.03-1800.15-175.03-1800.15,0,0,339.24,644.56-323.58,1699.48-129.6,206.26-229.89,429.63-292.2,665.12-155.92,588.85-184.16,1511.71,1011.49,1820.87-101.29-100.9-179.86-223.52-231.81-356.58-64.45-165.36-88.01-346.83-63.23-522.63,22.25-158.3,92.92-338.01,249.15-406.53,42.05-18.49,86.02-29.01,131.29-34.38,173.88-20.56,366.17,35.91,536.67,18.18,137.12-14.19,219.53-103.28,178.71-244.47-15.19-52.49-81.57-166.82-14.89-209.25,77.04-38.52,64.99-114.79,64.99-114.79-7.6-87.55-83.87-95.84-83.87-95.84,188.76-96.68,72.51-207.64,72.51-207.64-17.65-18.26-19.8-37.91-16.27-54.71,4.68-22.41,20.72-40.82,41.43-50.64Z"/>
                    <path
                      d="M1969.18,2168.1c634.03-829.12,699.68-1250.05,704.5-1363.71.87-21.73-16.81-42.32-16.81-42.32-18.05,27.31-39.62,55.06-60.92,80.73-30.92,38.03-69,79.56-102.57,115.41-178.61,186.1-378.32,354.13-583.04,511.11-162.3,127.89-338.56,241.66-503.67,366.38-404.07,313.87-586.95,788.9-497.69,1292.88,12.09,68.18,28.16,135.83,51.63,200.99-44.42-131.04-64.57-269.77-67.74-407.78-12.41-426.56,187.3-815.15,525.64-1071.01,164.48-121.25,344.73-234.93,507.76-360.38,193.86-145.14,383.57-300.26,555.84-470.76,53.84-53.98,107.42-109.42,155.72-168.92-210.21,446.16-378.87,553.72-690.01,873.78-1602.33,1648.2,138.39,2583.6,152.48,2590.89-9.49-12.43-882.14-1165.23-131.12-2147.28Z"/>
                  </g>
                </svg>
                <span class="text-sm text-gray-500 ml-2 whitespace-nowrap">: {{ 'onlyForWomen' | translate }}</span>
              </div>
            }
          </div>
          <div class="h-80 overflow-y-auto flex flex-col gap-2">
            @for (slot of slots; track slot) {
              <button (click)="selectSlot(slot)" tabindex="0" onKeyUp (keyup.enter)="emulateClick($event)"
                      [disabled]="selectSlotProgress()"
                      class="flex flex-row cursor-pointer w-100 text-gray-800 text-center font-semibold
                       justify-center relative p-4 group
                    border-2 border-gray-200 rounded-lg place-content-between hover:border-100ciels-300
                    hover:bg-100ciels-300 hover:text-white"
                      [ngClass]="{
                    'border-100ciels-300 bg-100ciels-300 text-white': selectedSlot() === slot,
                    'disabled:bg-gray-300 disabled:text-white': selectedSlot() !== slot
                    }">
                <span>{{ slot }}</span>
                @if (womanOnly(slot)) {

                  <svg viewBox="0 0 5000 5000" class="w-8 h-full absolute right-4 top-0 bottom-0 group-hover:fill-white"
                       [ngClass]="{
                    'fill-white': selectedSlot() === slot,
                    'fill-black': selectedSlot() !== slot
                    }">
                    <g>
                      <path
                        d="M3953.91,2313.46c160.3-75.58,167.2-133.98,155.61-163.13-4.07-10.36-11.66-18.8-20.95-24.94-83.48-55.02-154.85-127.68-218.23-204.57-26.7-32.46-53.64-67.06-75.51-104.43,96.07-34.84,159.76-112.65,159.76-112.65-64.15,42.28-140.65,55.71-185.54,59.93-1.61-3.91-3.3-7.83-4.68-11.82-25.32-71.67-17.57-150.01-31.15-224.06-22.33-122.08-60.39-241.32-116.4-352.2-81.11-160.37-199.58-301.33-345.37-406.61-58.01-41.9-122.08-82.87-189.91-107.2,182.39,246.62,257.21,593.22,242.55,893.55-14.89,305.63-129.22,588.31-295.34,841.76-169.35,258.21-355.73,497.46-436.92,800.94-51.64,193.14-60.77,394.33-28.08,586.08-7.21-15.42-244.55-543.5,304.78-1576.71,603.73-1135.49-175.03-1800.15-175.03-1800.15,0,0,339.24,644.56-323.58,1699.48-129.6,206.26-229.89,429.63-292.2,665.12-155.92,588.85-184.16,1511.71,1011.49,1820.87-101.29-100.9-179.86-223.52-231.81-356.58-64.45-165.36-88.01-346.83-63.23-522.63,22.25-158.3,92.92-338.01,249.15-406.53,42.05-18.49,86.02-29.01,131.29-34.38,173.88-20.56,366.17,35.91,536.67,18.18,137.12-14.19,219.53-103.28,178.71-244.47-15.19-52.49-81.57-166.82-14.89-209.25,77.04-38.52,64.99-114.79,64.99-114.79-7.6-87.55-83.87-95.84-83.87-95.84,188.76-96.68,72.51-207.64,72.51-207.64-17.65-18.26-19.8-37.91-16.27-54.71,4.68-22.41,20.72-40.82,41.43-50.64Z"/>
                      <path
                        d="M1969.18,2168.1c634.03-829.12,699.68-1250.05,704.5-1363.71.87-21.73-16.81-42.32-16.81-42.32-18.05,27.31-39.62,55.06-60.92,80.73-30.92,38.03-69,79.56-102.57,115.41-178.61,186.1-378.32,354.13-583.04,511.11-162.3,127.89-338.56,241.66-503.67,366.38-404.07,313.87-586.95,788.9-497.69,1292.88,12.09,68.18,28.16,135.83,51.63,200.99-44.42-131.04-64.57-269.77-67.74-407.78-12.41-426.56,187.3-815.15,525.64-1071.01,164.48-121.25,344.73-234.93,507.76-360.38,193.86-145.14,383.57-300.26,555.84-470.76,53.84-53.98,107.42-109.42,155.72-168.92-210.21,446.16-378.87,553.72-690.01,873.78-1602.33,1648.2,138.39,2583.6,152.48,2590.89-9.49-12.43-882.14-1165.23-131.12-2147.28Z"/>
                    </g>
                  </svg>
                }
                @if (selectSlotProgress() && selectedSlot() === slot) {
                  <svg class="animate-spin h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg"
                       fill="none"
                       viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                }
              </button>
            }
          </div>
        </div>
      }
    }
    @if (actualSlot(); as slot) {
      <div class="absolute left-2 right-2 bottom-40 md:top-12 md:bottom-12 md:left-12 md:right-12 m-auto">
        <div class="shadow-2xl shadow-gray-700 rounded-xl bg-white p-4">
          <p class="font-semibold text-gray-800 mb-6">{{ 'reservationFor' | translate }} :</p>
          <div class="flex gap-3">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="w-10 h-6 fill-gray-500">
              <path
                d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"/>
            </svg>
            <p class="text-100ciels-500 text-center whitespace-pre-line">
              <span class="font-semibold">{{ 'product/' + product().id + '/name' | translate }}</span><br>
              {{
                'bookedFor.v2' | translate : {
                  date: (selectedDay()?.availabilities?.date | date),
                  time: isRituel() ? slot[1].start : slot[0].start
                }
              }}
            </p>
          </div>
          <div class="px-6 flex gap-4 mt-4">
            <button class="grow py-3 main-btn bg-gray-400 hover:bg-gray-300" (click)="actualSlot.set(null)">
              {{ 'cancel' | translate }}
            </button>
            <button class="grow py-3 main-btn"
                    appHoverGradient [appProgressClick]="planSpa">
              {{ 'validate' | translate }}
            </button>
          </div>
        </div>
      </div>
    }
  </div>
}
